let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jCLhY")).then(() => parcelRequire('aiZVu'));